import { render, staticRenderFns } from "./o-microcart.vue?vue&type=template&id=27d146a6&"
import script from "./o-microcart.vue?vue&type=script&lang=js&"
export * from "./o-microcart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports